import TAXApi from './_taxApi';
import httpClient from '@/apis/base/httpclient';

class TAEnterpriseIncomeTaxAPI extends TAXApi {
  constructor() {
    super();
  }
  controllerName = 'TAEnterpriseIncomeTaxs';


  /**
   * Lấy ra tờ khai lập lần cuối
   * @param {*} payload
   * @returns
   * tvhien 09.01.2023
   */
  async GetTAEnterpriseIncomeTaxLasted(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/GetTAEnterpriseIncomeTaxLasted',
      data: payload,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Lấy ra tờ khai lập theo năm và tháng
   * @param {*} payload
   * @returns
   * tvhien 09.01.2023
   */
  async getTACircularVATByYearAndAriseDate(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getTACircularVATByYearAndAriseDate',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy danh sách chứng từ thiếu điều kiện
   * @param {*} payload
   * @returns
   * NNLINH 13.01.2023
   */
  async GetDataInvalidate(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DataInvalidate',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy danh sách chứng từ thiếu mua hàng với hóa đơn thường
   * @param {*} payload
   * @returns
   * NNLINH 27.01.2023
   */
  async GetPurchaseWithAllInvoice(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/PurchaseWithAllInvoice',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Thêm mới bảng kê mua vào/bán ra
   * @param {*} payload
   * @returns
   * NNLINH 27.01.2023
   */
  async GetNewPurchaseSaleList(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/PurchaseSaleList',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy chứng từ thỏa mãn PL 43/2022
   * @param {*} payload
   * @returns
   * dqvinh 1.2.2022
   */
  async GetTaVATDeclarationAppendix(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/GetTaVATDeclarationAppendix',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Danh sách chứng từ chọn lại
   * @param {*} payload
   * @returns
   * NNLINH 27.01.2023
   */
  async GetDataChoose(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/PurchaseSalelistChoose',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Xuất khẩu báo cáo Xml
   * NHANH3 17.1.2023
   */
  export(param) {
    let request = {
      url: this.getAPIUrl() + '/Export',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy ra tất cả tờ khai lập theo năm và tháng
   * @param {*} payload
   * @returns
   * tvhien 30.01.2023
   */
  async getAllTACircularVATByYearAndMonth(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/GetAllTACircularVATByYearAndMonth',
      data: payload,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Hàm lấy lại dữ liệu theo công thức khi đã cất chứng từ
   * NHANH3 15.04.2024 
   */
  async getAgainDataEdit(param) {
    let request = {
      url: this.getAPIUrl() + '/GetAgainDataEdit',
      data: param,
    };

    return httpClient.postAsync(request);
  }
}

export default new TAEnterpriseIncomeTaxAPI();
